<template>
  <q-page class="q-pa-md" v-if="isReady">

    <div class="text-h6">
      Git settings
    </div>
    <q-form @submit="saveProperties">

      <q-input label="Git url" v-model="properties.gitUrl"/>
      <q-input type="password" label="Git password" v-model="properties.gitPassword"/>

      <q-separator/>
      <q-btn type="submit" label="Save" color="primary" class="q-mt-md"/>
    </q-form>

  </q-page>
</template>

<script>

import {integrationsMixin} from "@/pages/workspace/integrations/integrationsMixin";

export default {
  components: {},
  mixins: [integrationsMixin],
  name: "GitIntegrationSettings",
  data: () => ({
    placement: {},
  }),

  computed: {

    /**
     * Return integration name
     */
    integration: () => ({name: "git", type: "cvs"}),
  }
}

</script>
